module.exports = __webpack_public_path__ + "static/media/marnie-lose.ffe3a0ce.png";